export default [
    {
        name: "Wollongong, Australia",
        properties:{
            NAME: "Wollongong, Australia",
        },
        amount: 5,
        location: {
            latitude: -34.42507,
            longitude: 150.89315
        }
    },
    {
        name: "Newcastle, Australia",
        properties:{
            NAME: "Newcastle, Australia",
        },
        amount: 13,
        location: {
            latitude: -32.92669,
            longitude: 151.77892
        }
    },
    {
        name: "João Pessoa, Brazil",
        properties:{
            NAME: "João Pessoa, Brazil",
        },
        amount: 12,
        location: {
            latitude: -7.11532,
            longitude: -34.861
        }
    },
    {
        name: "Great Bend, KS, USA",
        properties:{
            NAME: "Great Bend, KS, USA",
        },
        amount: 83,
        location: {
            latitude: 38.364895,
            longitude: -98.774300
        }
    }
]